import { render } from "./GatewaysBySiteList.vue?vue&type=template&id=61d696e0"
import script from "./GatewaysBySiteList.vue?vue&type=script&lang=js"
export * from "./GatewaysBySiteList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__